var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSkippay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 111,
  height: 51,
  fill: "none",
  viewBox: "0 0 111 51"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1E82F0",
  d: "M60.854 15.6a7.525 7.525 0 1 1-13.033-7.525A7.525 7.525 0 0 1 60.854 15.6"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E82F0",
  d: "M43.77 21.664a4.515 4.515 0 1 1-7.82-4.515 4.515 4.515 0 0 1 7.82 4.515"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.608 42.598q-.873 1.44-2.574 2.298t-4.122.858q-3.648 0-6.007-1.777-2.36-1.778-2.574-4.965h5.578q.12 1.225.873 1.93.75.706 1.915.706 1.012 0 1.594-.552t.582-1.471q0-.828-.536-1.38a4.2 4.2 0 0 0-1.333-.903 31 31 0 0 0-2.207-.843q-2.053-.704-3.355-1.364-1.304-.66-2.238-1.961T.27 29.787q0-1.93.98-3.34.981-1.41 2.712-2.161 1.732-.75 3.97-.75 3.616 0 5.746 1.715 2.13 1.717 2.406 4.72h-5.67q-.154-1.073-.782-1.7-.629-.63-1.7-.63-.921 0-1.487.492-.567.49-.567 1.44 0 .766.506 1.302.505.537 1.271.874t2.207.858q2.084.704 3.402 1.394 1.317.69 2.268 2.007.95 1.319.95 3.433a5.97 5.97 0 0 1-.874 3.157"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m29.533 45.54-5.118-7.264v7.264h-5.241V23.526h5.24v11.778l5.119-6.865h6.16l-6.896 8.55 7.049 8.55z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42.48 28.439V45.54h-5.242V28.439z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M60.15 29.282q1.67 1.056 2.635 3.034.966 1.977.966 4.673 0 2.667-.966 4.659-.965 1.992-2.635 3.05-1.671 1.056-3.785 1.056-1.962 0-3.372-.889a5.16 5.16 0 0 1-2.053-2.42v8.336H45.7V28.439h5.24v3.095a5.16 5.16 0 0 1 2.053-2.421q1.41-.889 3.371-.889 2.115 0 3.786 1.058m-8.183 4.658q-1.058 1.119-1.058 3.05 0 1.9 1.058 3.033t2.712 1.134q1.685 0 2.712-1.103t1.027-3.065q0-1.96-1.027-3.065-1.028-1.103-2.712-1.103-1.655 0-2.712 1.119"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E82F0",
  d: "M106.685 34.464c-6.233 10.797-20.038 14.496-30.834 8.263-10.797-6.234-14.496-20.039-8.263-30.835C73.822 1.095 87.628-2.604 98.423 3.629c10.797 6.234 14.496 20.039 8.262 30.835"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M74.58 24.455v4.387h-3.025V16.335h4.9q2.229 0 3.396 1.105 1.168 1.107 1.168 2.981 0 1.168-.522 2.08-.522.91-1.548 1.432t-2.494.522zm3.36-4.033q0-1.646-1.821-1.646h-1.54v3.255h1.54q1.822 0 1.822-1.61"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M87.817 19.36q.813.513 1.203 1.398V18.97h3.007v9.871H89.02v-1.786q-.39.884-1.203 1.397t-1.946.513q-1.22 0-2.185-.61t-1.521-1.76q-.558-1.15-.558-2.69 0-1.555.558-2.697.556-1.141 1.521-1.751t2.185-.61q1.132 0 1.946.512m-2.538 2.778q-.594.636-.593 1.769 0 1.131.592 1.769.593.637 1.566.637.956 0 1.566-.655.61-.654.61-1.751 0-1.115-.61-1.76-.611-.646-1.566-.646-.973 0-1.565.637"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M104.296 18.97h-3.343l-2.211 6.05-2.371-6.05h-3.379l4.14 9.5-1.544 3.383h3.268z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .602h110.236v50.283H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.27.602h109.624v50.283H.27z"
})))));
export default SvgSkippay;